import React,{useState,useEffect,useContext} from "react"
import Api from "./Api";
import LoadingMask from "./LoadingMask";
import AppContext from "./AppContext";
import { useGlobal } from "./Reducer";
export default (props)=>{

const [error,setError]=useState(false);
const [username,setUserName]=useState("");
const [password,setPassword]=useState("");
const [globalState, globalActions] = useGlobal(); 

const login=()=>{
    setError(false);
    globalActions.loading(true);
    
    Api.login(username,password).then(resp=>{
        console.log(".....");
        globalActions.loading(false);
        location.reload();
    }).catch(err=>{
        setError(err+"");
    }).finally(()=>{
        globalActions.loading(false);
    })

}


return (

<div  style={{backgroundColor:"#f0f1ef"}} >
   
    <LoadingMask/>
<div className="container">

    <div className="form-login">
        <h2 className="form-login-heading">sign in now</h2>
        <div className="login-wrap">
            
            
            
            <input value={username} 
            onChange={e=>setUserName(e.target.value)}
            autoComplete="username" type="text" className="form-control" id="user_name" placeholder="User ID" autoFocus />
            <br/>
            <input 
            value={password}
            onChange={e=>setPassword(e.target.value)}
            autoComplete="current-password" type="password" className="form-control" id="password" placeholder="Password" />

          {error &&  <label className="checkbox">
                <div className="centered alert alert-danger" id="login_error" style={{margin:10}}  >
                {error}
                </div>
                <span className="pull-right">
                 
                </span>
            </label>}
              <br/>
              
            <button onClick={login}  className="btn btn-secondary btn-block"><i className="fa fa-lock"></i> LOG IN</button>


            <hr/>
 
            
            <div className="registration">
                Montly E-Newsletter
                <br/>Admin Login
                <br/>

            </div>

        </div>

     
    </div>
</div>
</div>);


}